import React from 'react'

import { codeBoardMap } from '../index'

const BoardIcon = ({ code }: { code: string }) => {
  const item = codeBoardMap.get(code)
  const Icon = item?.icon

  return <>{Icon ? <Icon size={16} /> : null}</>
}

export default BoardIcon
